import { motion } from "framer-motion";

const INSTITUTIONAL_IMG = "https://images.unsplash.com/photo-1548950308-69fac3b90a45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjczNjMwNHww&ixlib=rb-4.1.0&q=85";

export const Institutional = () => {
  return (
    <section
      id="institucional"
      className="relative py-24 md:py-32 lg:py-40 overflow-hidden"
      data-testid="institutional-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image side */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
            className="lg:col-span-5 relative"
          >
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={INSTITUTIONAL_IMG}
                  alt="Edifício corporativo"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Gold frame offset */}
              <div className="absolute -bottom-6 -right-6 w-full h-full border border-[#D4B366]/50 -z-10" />
              <div className="absolute -top-6 -left-6 w-24 h-24 border-t border-l border-[#D4B366]" />
            </div>
          </motion.div>

          {/* Text side */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, delay: 0.2 }}
            className="lg:col-span-7 lg:pl-8"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="gold-divider" />
              <span className="eyebrow">Sobre Nós</span>
            </div>

            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#F5F1EA] mb-10" data-testid="institutional-title">
              Muito além de{" "}
              <span className="italic gold-text">anunciar</span> um imóvel
            </h2>

            <div className="space-y-6 text-[#A2AAC2] text-base md:text-[1.02rem] leading-[1.85] font-light max-w-xl">
              <p>
                Na locação não residencial, encontrar um inquilino não basta. É preciso encontrar
                o <span className="text-[#E8C97A] font-normal">inquilino certo</span>, com perfil
                compatível, operação alinhada ao espaço e maior potencial de permanência.
              </p>
              <p>
                A <span className="text-[#F5F1EA] font-normal">Parceria Certa Imobiliária</span> atua
                de forma especializada na intermediação de imóveis comerciais, industriais e
                corporativos, conectando proprietários e empresas com mais precisão, inteligência
                de mercado e foco em bons negócios.
              </p>
              <p>
                Nosso trabalho é tornar o processo de locação mais seguro, estratégico e eficiente
                para todas as partes.
              </p>
            </div>

            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, delay: 0.5 }}
              className="mt-12 origin-left h-[1px] w-32 bg-gradient-to-r from-[#D4B366] to-transparent"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
